// ============================================
// Brand Display Service
// Loads brand display context for the patient-
// facing Analyst Bar chat. Wraps docopsService
// getBrand() and maps to BrandDisplayContext.
// ============================================

import { getBrand } from './docopsService';
import type { BrandDisplayContext } from '../../types/analystBar';

// ── Brand display fallback monitoring (D1) ──
let brandDisplayFallbackCount = 0;

// ── Default brand display (HemoLogix defaults / demo mode) ──

export const DEFAULT_BRAND_DISPLAY: BrandDisplayContext = {
  medicalDirectorName: 'Dr. Christopher Calapai, D.O.',
  retestWeeks: 8,
  shippingDays: 2,
  hsaFsaEligible: true,
};

// ── Load brand display context from Firestore ──

export async function loadBrandDisplay(
  brandId: string,
): Promise<BrandDisplayContext> {
  try {
    const brand = await getBrand(brandId);

    if (!brand) {
      return { ...DEFAULT_BRAND_DISPLAY };
    }

    return {
      medicalDirectorName:
        brand.config.medicalDirectorName || DEFAULT_BRAND_DISPLAY.medicalDirectorName,
      retestWeeks: brand.config.retestWeeks ?? DEFAULT_BRAND_DISPLAY.retestWeeks,
      shippingDays: brand.config.shippingDays ?? DEFAULT_BRAND_DISPLAY.shippingDays,
      hsaFsaEligible: brand.config.hsaFsaEligible ?? DEFAULT_BRAND_DISPLAY.hsaFsaEligible,
    };
  } catch (err) {
    brandDisplayFallbackCount++;
    console.warn('[BrandDisplay] Firestore unavailable, using defaults:', err instanceof Error ? err.message : err);
    if (brandDisplayFallbackCount > 3) {
      console.error('[BrandDisplay] ALERT: Firestore fallback triggered >3 times. Check configuration.');
    }
    return { ...DEFAULT_BRAND_DISPLAY };
  }
}
